import { forwardRef } from 'react';
import { ComponentFrameworkPrintTemplate } from '@utils/component-framework';
import { img } from './organism.print.style.js';
import { jsx } from 'react/jsx-runtime';

const PrintLayout = /*#__PURE__*/forwardRef(function PrintLayout(props, ref) {
  return /*#__PURE__*/jsx(ComponentFrameworkPrintTemplate, {
    children: /*#__PURE__*/jsx("img", {
      ref: ref,
      alt: "",
      className: img
    })
  });
});

export { PrintLayout };
//# sourceMappingURL=organism.print.js.map
